import { CommonModule } from '@angular/common';
import { Component, Input, signal, ChangeDetectionStrategy } from '@angular/core';
import { Installation, Contact } from '../../Services/EntiteProjet';

@Component({
  selector: 'app-installation-contacts-panel',
  imports: [CommonModule],
  templateUrl: './installation-contacts-panel.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './installation-contacts-panel.css',
})
export class InstallationContactsPanelComponent {
  @Input() installation: Installation | null = null;

  ouvert = signal(false);

  readonly groupes: {
    label: string;
    key: keyof Pick<Installation, 'mos' | 'bes' | 'installateurs' | 'mainteneurs'>;
  }[] = [
    { label: "Maître d'ouvrage", key: 'mos' },
    { label: "Bureau d'études", key: 'bes' },
    { label: 'Installateurs', key: 'installateurs' },
    { label: 'Mainteneurs', key: 'mainteneurs' },
  ];

  contacts(
    key: keyof Pick<Installation, 'mos' | 'bes' | 'installateurs' | 'mainteneurs'>,
  ): Contact[] {
    return (this.installation?.[key] as Contact[] | undefined) ?? [];
  }
}
